// extracted by mini-css-extract-plugin
module.exports = {"creator-flag":"CreatorFlag_creator-flag__wNs9c"};